"use strict";
'use es6';

require("i18n-data/static-1.70/data/baseLocales");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/init/data/baseLocales.js
// module id = 614
// module chunks = 209 210 211 212